import { useParams } from 'react-router-dom'

import {
  useVenueReferAFriendButtonVenueContextQuery,
  useVenueReferAFriendButtonViewerIsCustomerQuery,
} from '../../../../../graphql'

export function useVenueReferAFriendData() {
  const { venueSlug } = useParams<{ venueSlug: string }>()
  const { data } = useVenueReferAFriendButtonVenueContextQuery({ variables: { slug: venueSlug } })
  const venue = data?.venueContext.venue
  const referral = venue?.company.referral ?? null

  let customerData = null
  if (venue?.id) {
    const { data } = useVenueReferAFriendButtonViewerIsCustomerQuery({
      variables: { venueId: venue?.id },
      skip: !venue?.id,
    })
    customerData = data
  }

  const isCustomer = (customerData?.me?.customers.nodes.length ?? 0) > 0

  return { venue, referral, isCustomer }
}
